<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Acreedores" :content="meta.total" icon="users" />
      <sys-widget title="Inversión estimada" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import investorService from '@/services/investors'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'

export default {
  name: 'Investors',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Acreedores',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'fullname' },
        { text: 'Promotor', value: 'promoter_name' },
        { text: 'Monto de inversión', value: 'investments_amount', filter: formatCurrency },
        { text: 'Inversiones', value: 'investments_count' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Tipo', value: 'type' }
      ],
      items: [],
      filtered_items: [],
      items_sum: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'investor',
      create_route: 'investor_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'fullname',
          name: 'Acreedor',
          hint: 'Acreedor',
          icon: 'user',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.fullname.toLowerCase().includes(value.toLowerCase()) || (item.corporate_name && item.corporate_name.toLowerCase().includes(value.toLowerCase()))
        },
        {
          id: 'email',
          name: 'Correo electrónico',
          hint: 'Correo electrónico',
          icon: 'mail-bulk',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.email.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'promoter',
          name: 'Promotor',
          hint: 'Promotor',
          icon: 'user',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.promoter_name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'type',
          name: 'Tipo de persona',
          hint: 'Todos',
          icon: 'users',
          type: 'select',
          value: '',
          options: [
            { value: 'Fisica', text: 'Fisica' },
            { value: 'Moral', text: 'Moral' }
          ],
          size: 3,
          validator: (item, value) => item.type == value
        },
        {
          id: 'investment_from',
          name: 'Inversión Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 6,
          value: '',
          validator: (item, value) => item.investments_amount >= value
        },
        {
          id: 'investment_to',
          name: 'Inversión Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 6,
          value: '',
          validator: (item, value) => item.investments_amount <= value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      investorService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/investors/Investors.vue